// extracted by mini-css-extract-plugin
export default {"ranger":"FourImages_ranger__anGSl","col":"FourImages_col__NJXW-"};